import React from 'react';
import { X, Clock, Calendar } from 'lucide-react';
import { VideoPlayer } from './VideoPlayer';
interface VideoPlayerModalProps {
  video: {
    id: number;
    title: string;
    topic: string;
    duration: string;
    thumbnail: string;
    description?: string;
  };
  onClose: () => void;
}
export function VideoPlayerModal({
  video,
  onClose
}: VideoPlayerModalProps) {
  // Function to get subject-specific placeholder image
  const getSubjectPlaceholder = (topic: string) => {
    // Based on topic, determine which subject it might be
    if (topic.toLowerCase().includes('üslü') || topic.toLowerCase().includes('köklü') || topic.toLowerCase().includes('olasılık') || topic.toLowerCase().includes('eşitsizlik')) {
      return 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWF0aCUyMHByb2JsZW18ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60';
    } else if (topic.toLowerCase().includes('sözcük') || topic.toLowerCase().includes('deyim') || topic.toLowerCase().includes('paragraf')) {
      return 'https://images.unsplash.com/photo-1457369804613-52c61a468e7d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Ym9va3MlMjBhbmQlMjBwZW58ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60';
    } else if (topic.toLowerCase().includes('dna') || topic.toLowerCase().includes('basınç') || topic.toLowerCase().includes('madde') || topic.toLowerCase().includes('elektrik')) {
      return 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2NpZW5jZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60';
    } else {
      return 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZWR1Y2F0aW9ufGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60';
    }
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1333">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-4xl" data-id="element-1334">
        <div className="relative bg-black/90 rounded-xl p-6" data-id="element-1335">
          <div className="flex justify-between items-center mb-4" data-id="element-1336">
            <h2 className="text-xl font-bold" data-id="element-1337">{video.title}</h2>
            <button onClick={onClose} className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-id="element-1338">
              <X className="w-5 h-5" data-id="element-1339" />
            </button>
          </div>
          <VideoPlayer videoUrl="https://www.youtube.com/embed/dQw4w9WgXcQ" thumbnailUrl={video.thumbnail || getSubjectPlaceholder(video.topic)} enableFullscreen={true} data-id="element-1340" />
          <div className="mt-4 space-y-4" data-id="element-1341">
            <div className="flex items-center justify-between" data-id="element-1342">
              <div className="flex items-center gap-2 text-gray-400" data-id="element-1343">
                <Clock className="w-4 h-4" data-id="element-1344" />
                <span data-id="element-1345">{video.duration}</span>
              </div>
              <button className="flex items-center gap-2 px-3 py-1.5 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-1346">
                <Calendar className="w-4 h-4 text-purple-400" data-id="element-1347" />
                <span className="text-sm" data-id="element-1348">Programa Ekle</span>
              </button>
            </div>
            {video.description && <div data-id="element-1349">
                <h3 className="text-lg font-medium mb-2" data-id="element-1350">Açıklama</h3>
                <p className="text-gray-400" data-id="element-1351">{video.description}</p>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}